import classNames from 'classnames';
import React, { CSSProperties, useEffect } from 'react';
import Masonry from 'react-masonry-css';
import VerticalMasonryList, { EnkiCard } from './vertical-masonry-list';
import SKELETONIMAGE from '@/assets/images/skeletonImage.png';

import styles from './index.module.scss';

/* 按钮 */
type btnProps = Partial<{
  size?: string; // small, default, large
  shape?: string; // round, default, circle
  style?: CSSProperties & Record<string, any>;
  className?: string;
}>;
const Button = (props: btnProps) => {
  const { style, size = 'default', shape = 'default', className } = props;
  return <div style={style} className={classNames(styles.button, styles[shape], styles[size], className)}></div>;
};

/* 商品卡片 */
type cardProps = Partial<{
  className?: string;
  horizontal?: boolean;
  style?: any;
  animation?: boolean;
  viewRef?: any;
}>;
const Card = (props: cardProps) => {
  const { style, className, horizontal = false, animation, viewRef } = props;
  const card = (
    <div
      ref={viewRef}
      style={style}
      className={classNames(styles.card, styles.normal, { [styles.animate]: animation }, className)}>
      {/* <Icon type="image" /> */}
    </div>
  );
  const skeleton_horizontal_card = (
    <div ref={viewRef} style={style} className={classNames(styles.card, styles.horizontal, className)}>
      <div className={styles.image}></div>
      <div className={styles.content}>
        <div className={styles.paragraph}>
          <div className={styles.longParagraph}></div>
          <div className={styles.shortParagraph}></div>
        </div>
        <div className={styles.row}>
          <div className={styles.num}></div>
          <div className={styles.btn}></div>
        </div>
      </div>
    </div>
  );
  return <>{horizontal ? skeleton_horizontal_card : card}</>;
};

/* 图片 */
type imageProps = Partial<{
  className?: string;
  style?: any;
  imgClassName?: string;
}>;
const Image = (props: imageProps) => {
  const { style, className, imgClassName } = props;
  return (
    <div style={style} className={classNames(className, styles.image)}>
      <img
        src={SKELETONIMAGE}
        className={classNames(styles.skeletonImage, imgClassName)}
        alt="Weee! - Skeleton button image"
      />
    </div>
  );
};

/* 段落 */
type paraProps = Partial<{
  className?: string;
  rows?: number;
  style?: any;
}>;
const Paragraph = (props: paraProps) => {
  const { style, className, rows = 1 } = props;
  let arr = [],
    i = rows;
  while (i--) {
    arr[i] = 0;
  }

  return (
    <ul style={style} className={classNames(styles.paragraph, className)}>
      {arr.map((item, index) => (
        <li key={index}></li>
      ))}
    </ul>
  );
};

/* 段落 */
type Sprops = Partial<{
  className?: string;
  rows?: number;
  style?: any;
}>;
const SectionCard = (props: Sprops) => {
  const { style, className, rows = 2 } = props;
  let arr = [],
    i = rows;
  while (i--) {
    arr[i] = 0;
  }

  return (
    <ul style={style} className={classNames(styles.sectionCard, className)}>
      {arr.map((item, index) => (
        <div key={index}>
          <div className={styles.title}>
            <Skeleton.Button />
            <Skeleton.Button />
          </div>
          <div className={styles.list}>
            <Skeleton.Card style={{ marginRight: '8px' }} />
            <Skeleton.Card style={{ marginRight: '8px' }} />
            <Skeleton.Card />
          </div>
        </div>
      ))}
    </ul>
  );
};

/* list */
type listProps = Partial<{
  length?: number;
  className?: string;
  cardClassName?: string;
  style?: any;
  horizontal?: boolean;
  viewRef?: any;
}>;
const List = (props: listProps) => {
  const { style, className, cardClassName, length = 8, horizontal = false, viewRef } = props;
  let arr = [],
    i = length;
  while (i--) {
    arr[i] = 0;
  }
  const card_list = (
    <div className={classNames(styles.cardList, className)} style={style} ref={viewRef}>
      <Masonry breakpointCols={2} className={styles.masonryList} columnClassName={styles.masonryColumn}>
        {arr.map((item, index) => (
          <div key={index} className={styles.masonryCard}>
            <Skeleton.Card />
          </div>
        ))}
      </Masonry>
    </div>
  );
  const horizontal_card_list = (
    <div className={classNames(styles.cardList, className)} style={style} ref={viewRef}>
      {arr.map((item, index) => (
        <Skeleton.Card key={index} horizontal={true} style={{ marginBottom: '8px' }} className={cardClassName} />
      ))}
    </div>
  );
  return <>{horizontal ? horizontal_card_list : card_list}</>;
};

/* ***************************************** */
export enum SkeletonTypes {
  button = 'button',
  card = 'card',
  horizontalCard = 'horizontalCard',
  avatar = 'avatar',
  image = 'image'
}

type Props = Partial<{
  type: keyof typeof SkeletonTypes;
  limit?: number;
}>;

type skeletonProps = React.FC<Props> & { Button: btnProps; Card: cardProps; Image: imageProps };

function Skeleton(props: skeletonProps) {
  return <></>;
}

Skeleton.Button = Button;
Skeleton.Image = Image;
Skeleton.Card = Card;
Skeleton.Paragraph = Paragraph;
Skeleton.List = List;
Skeleton.SectionCard = SectionCard;
Skeleton.VerticalMasonryList = VerticalMasonryList;
Skeleton.EnkiCard = EnkiCard;

export default Skeleton;
